export default [
  { value: null, text: "Todos" },
  { value: "Rede", text: "Rede" },
  { value: "Cielo", text: "Cielo" },
];
